import { FormattedMessage, useIntl } from "react-intl";
import Example from "../../test/intro/Example";
import assesmentTest from "./assesmentTest.json";

const DemoProfessionalTestIntro =  (props) => {
  const { pref_lang } = props;
  const intl = useIntl();
  return (
    <section id="demo-professional-test-intro">
      {pref_lang === 'en' &&
      <h1>{assesmentTest['test']?.nom_en}</h1>
    }
    {pref_lang != 'en' &&
      <h1>{assesmentTest['test']?.nom}</h1>
  }
      <h3>
        <FormattedMessage id="user-test.title.instructions" />
      </h3>
      <div
        id="intro-instructions"
        dangerouslySetInnerHTML={{ __html: assesmentTest['test']['message_intro_'+pref_lang] }}
      />
      
      <div style={{border: "1px solid lightgrey", padding:"20px", marginBottom: "60px"}}>
      <Example test={assesmentTest['test']} />
      </div>

      <p><FormattedMessage id="demo.professional.test.intro.p1" values={{
        StartLabel: <strong>{intl.formatMessage({id:"demo.professional.test.intro.p1_start_label"})}</strong>}}/></p>
      <div className="text-center">
        <button className="btn btn-primary btn-lg" onClick={()=>props.next()}><FormattedMessage id="user_test.label.start-test" /></button>
      </div>
    </section>
  );
};

export default DemoProfessionalTestIntro;